import React, { useState, useEffect } from "react";
import "./EventTab.css";
import Events from "../Tab Content/Events";
import { useNavigate } from "react-router-dom";

const EventTab = ({ selectedIndex }) => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(0);
  const [eventToolTipData, setEventToolTipData] = useState([]);

  const [editEventFromSubflow, setEditEventFromSubflow] = useState(false);
  const [editEventDetails, setEditEventDetails] = useState({});
  const [fromEventToTask, setFromEventToTask] = useState(false);

  const workflowMgmtTabList = ["Event Mapping", "Event Definition"];

  useEffect(() => {
    // dummy tooltip data
    setEventToolTipData(["Tip 1", "Tip 2", "Tip 3"]);
  }, []);

  const handleClick = (index) => {
    setActiveTab(index);
    setFromEventToTask(false);
    navigate(".", { replace: true, state: null });
  };

  const createEventOrTask = (changeIndex) => {
    handleClick(changeIndex);
    if (changeIndex === 1) setFromEventToTask(true);
  };

  return (
    <>
      {/* ===== TABS HEADER ===== */}
      <div className="tabsContainer">
        {workflowMgmtTabList.map((tab, index) => (
          <button
            key={index}
            className={`tabBtn ${activeTab === index ? "active" : ""}`}
            onClick={() => handleClick(index)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* ===== TAB CONTENT ===== */}
      <div className="tabContent">
        <Events
          key={activeTab}                 // 🔥 forces remount
          editEventFromSubflow={editEventFromSubflow}
          eventDetails={editEventDetails}
          createTask={createEventOrTask}
          toolTipData={eventToolTipData}
          eventCreation={activeTab === 1} // ✅ true/false based on tab
        />
      </div>
    </>
  );
};

export default EventTab;
